import styled from 'styled-components'
import { colors } from '../../theme'

export const FormLogin = styled.div`
  position: relative;
  &.focused label {
    color: ${colors.secondary};
  }
`
// export const ButtonEye = styled.button`
//   position: absolute;
//   top: 37px;
//   left: 355px;
//   border: none;
//   background-color: ${colors.surface};
// `
// export const LabelLogin = styled.label`
//   position: absolute;
//   top: 7px;
//   background: ${colors.surface};
//   left: 32px;
//   color: ${colors.secondary};
//   padding: 0 3px;
// `

// export const InputLogin = styled.input`
//   width: 400px;
//   height: 56px;
//   border: 1px solid ${colors.secondary};
//   border-radius: 16px;
//   margin-top: 20px; //retirar
//   margin-bottom: 15px;
//   font-size: 16px;
//   padding: 20px;
// `
export const ButtonEye = styled.button`
  position: absolute;
  top: 19px;
  left: 280px;
  border: none;
  background: none;
`

export const InputLogin = styled.input<{ marginBotton?: boolean }>`
  outline: none;
  width: 320px;
  height: 40px;
  border: 1px solid ${colors.grey300};
  border-radius: 10px;
  /* A margem do topo abre espaco para o rotulo flutuante (LabelLogin), que e
     absoluto e monta sobre a borda; mexer aqui exige mexer la tambem. */
  margin-top: 12px;
  margin-bottom: ${({ marginBotton }) => (marginBotton ? '0px' : '2px')};
  font-size: 13px;
  padding: 15px;
  padding-right: 55px;
  -webkit-text-fill-color: ${colors.white} !important;
  caret-color: ${colors.white} !important;
  /* MESMA cor do cartao, de proposito. O rotulo flutuante (LabelLogin) recorta
     a borda deste campo, e o recorte so desaparece se campo e cartao tiverem a
     mesma cor — com o campo mais fundo, o rotulo atravessa a fronteira entre os
     dois e vira uma caixa visivel. Quem delimita o campo aqui e a borda. */
  -webkit-box-shadow: 0 0 0px 1000px ${colors.login} inset !important;
  background: ${colors.login} !important;

  &:focus {
    border: solid 2px ${colors.secondary};
  }
`
export const LabelLogin = styled.label`
  position: absolute;
  top: 2px;
  background: ${colors.login};
  left: 6px;
  padding: 0 10px;
  font-size: 12px;
  color: ${colors.white};
  transition: color 0.3s;
`
